import { AnyAction } from 'redux';
import { SagaIterator } from 'redux-saga';
import { call, put, takeLatest } from 'redux-saga/effects';
import { fetchNextVideo, fetchVideoCategoriesByTopic, fetchVideoLanguages, fetchVideoTopics } from 'src/api/video';
import {
    FETCH_NEXT_VIDEO,
    FETCH_VIDEO_CATEGORIES,
    FETCH_VIDEO_LANGUAGES,
    FETCH_VIDEO_TOPICS,
    requestNextVideo,
    requestNextVideoFailure,
    requestNextVideoSuccess,
    requestVideoCategories,
    requestVideoCategoriesFailure,
    requestVideoCategoriesSuccess,
    requestVideoLanguages,
    requestVideoLanguagesFailure,
    requestVideoLanguagesSuccess,
    requestVideoTopics,
    requestVideoTopicsFailure,
    requestVideoTopicsSuccess,
} from './actions';

/* Video Topics */
function* fetchVideoTopicsSaga(action: AnyAction): SagaIterator {
    yield put(requestVideoTopics());

    const { error, response } = yield call(fetchVideoTopics);

    if (error) {
        yield put(requestVideoTopicsFailure(error));
    } else {
        yield put(requestVideoTopicsSuccess(response));
    }
}

export function* generateFetchVideoTopicsWatcher() {
    yield takeLatest(FETCH_VIDEO_TOPICS, fetchVideoTopicsSaga);
}

/* Video Categories by topic */
function* fetchVideoCategoriesSaga(action: AnyAction): SagaIterator {
    yield put(requestVideoCategories());

    const { error, response } = yield call(fetchVideoCategoriesByTopic, action.topic);

    if (error) yield put(requestVideoCategoriesFailure(error));
    else yield put(requestVideoCategoriesSuccess(response));
}

export function* generateFetchVideoCategoriesWatcher() {
    yield takeLatest(FETCH_VIDEO_CATEGORIES, fetchVideoCategoriesSaga);
}

/* Video Languages */
function* fetchVideoLanguagesSaga(action: AnyAction): SagaIterator {
    yield put(requestVideoLanguages());

    const { error, response } = yield call(fetchVideoLanguages, action.topic);

    if (error) yield put(requestVideoLanguagesFailure(error));
    else yield put(requestVideoLanguagesSuccess(response));
}

export function* generateFetchVideoLanguagesWatcher() {
    yield takeLatest(FETCH_VIDEO_LANGUAGES, fetchVideoLanguagesSaga);
}

/* Next Video */
function* fetchNextVideoSaga(action: AnyAction): SagaIterator {
    yield put(requestNextVideo());

    const { error, response } = yield call(fetchNextVideo);

    if (error) yield put(requestNextVideoFailure(error));
    else yield put(requestNextVideoSuccess(response));
}

export function* generateFetchNextVideoWatcher() {
    yield takeLatest(FETCH_NEXT_VIDEO, fetchNextVideoSaga);
}
